// extracted by mini-css-extract-plugin
export var messageSideLeft = "_t2-1";
export var stateContainer = "_t2-0";